import { render, staticRenderFns } from "./ModalLink.vue?vue&type=template&id=f29409d2&scoped=true"
import script from "./ModalLink.vue?vue&type=script&lang=js"
export * from "./ModalLink.vue?vue&type=script&lang=js"
import style0 from "./ModalLink.vue?vue&type=style&index=0&id=f29409d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29409d2",
  null
  
)

export default component.exports